import type { ReactElement } from 'react';

type Props = {
  breakdown: Record<string, number>;
};

const masteryColors: Record<string, string> = {
  'No Level': 'bg-gray-300',
  'Not Started': 'bg-gray-400',
  'Hard to Sightread': 'bg-red-400',
  'Good Sightreading': 'bg-amber-400',
  'Halfway Memorized': 'bg-yellow-400',
  'Memorized with Articulation/Dynamics': 'bg-green-400',
  'Performance Ready': 'bg-emerald-500',
};

const DEFAULT_COLOR = 'bg-gray-300';

export function MasteryDistribution({ breakdown }: Props): ReactElement {
  const entries = Object.entries(breakdown);

  if (entries.length === 0) {
    return <p className="text-sm text-[var(--ink-3)]">No repertoire data yet.</p>;
  }

  const maxCount = Math.max(...entries.map(([, count]) => count));

  return (
    <div className="space-y-2">
      {entries.map(([level, count]) => (
        <div key={level} className="flex items-center gap-2">
          <span className="text-xs w-40 truncate shrink-0">{level}</span>
          <div className="flex-1 h-4 bg-[var(--bg-soft)] rounded overflow-hidden">
            <div
              className={`h-full rounded ${masteryColors[level] ?? DEFAULT_COLOR}`}
              style={{ width: `${(count / maxCount) * 100}%` }}
            />
          </div>
          <span className="text-xs w-6 text-right tabular-nums">{count}</span>
        </div>
      ))}
    </div>
  );
}
